import cyMessages from "../locales/cy_GB";

const cyLang = {
  messages: {
    ...cyMessages,
  },
  locale: "cy-GB",
};
export default cyLang;
